import React, { useState, useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import * as Icons from "react-feather";
import { urlAPI, getUser, getToken } from "utility/Common";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Axios from "axios";
import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { Tab } from "bootstrap";

const headerStyle = {
  fontSize: "16px",
  color: "black",
  margin: "5px 5px 5px 5px",
};
const bodyStyle = {
  fontSize: "14px",
  color: "black",
  margin: "1px 1px 1px 1px",
};
const containerStyle = {
  padding: "1cm 1cm 1cm 1cm",
};
// const borderStyle = {
//   border: "2px solid black",
// };
// const borderTopNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "none solid solid solid",
// };
// const borderBottomNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "solid solid none solid",
// };
// const borderTopBottomNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "none solid none solid",
// };

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const data = this.props.dataPrint;

    console.log("dataPrint", data);
    return (
      <div style={containerStyle}>
        <Row>
          <Col>
            <img
              src="/assets/img/logopgm.png"
              alt="logo"
              className="img-responsive"
              style={{ height: "100px", margin: "10px 10px 10px 10px" }}
            />
          </Col>
          <Col>
            <img
              src="/assets/img/logotext.png"
              alt="logo"
              className="img-responsive"
              style={{
                height: "100px",
                margin: "10px 10px 10px 10px",
                float: "right",
              }}
            />
          </Col>
        </Row>
        <Table borderless={true}>
          <tbody>
            <tr>
              <td
                style={{
                  width: "50%",
                  verticalAlign: "top",
                  border: "solid black 1px",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "24px",
                    color: "black",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <strong>ORDER PEMBELIAN</strong>
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "black",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <strong>NON STOCK ITEMS</strong>
                </p>
              </td>
              <td
                style={{
                  width: "50%",
                  border: "solid black 1px",
                  verticalAlign: "top",
                }}
              >
                <p style={headerStyle}>
                  NOMOR &nbsp; &nbsp; &nbsp; : &nbsp;
                  {data?.NOPO?.substring(4).trim()}/
                  {moment(data?.TANGGALPO).format("DD/MM/YYYY")}/OPK/PGM02/
                  {moment(data?.TANGGALPO).format("YYYY")}
                </p>
                <p style={headerStyle}>
                  TANGGAL &nbsp; &nbsp; : &nbsp;
                  {moment(data?.TANGGALPO).format("DD/MM/YYYY")}
                </p>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  width: "50%",
                  border: "solid black 1px",
                  verticalAlign: "top",
                }}
              >
                <p style={headerStyle}>Kepada:</p>
                <p style={headerStyle}>{data?.NAMASUPPLIER}</p>
                <p style={headerStyle}>{data?.ALAMATSUPPLIER}</p>
                <p style={headerStyle}>{data?.KOTASUPPLIER}</p>
              </td>
              <td
                style={{
                  width: "50%",
                  border: "solid black 1px",
                  verticalAlign: "top",
                }}
              >
                <p style={headerStyle}>Referensi Surat Penawaran Rekanan</p>
                <p style={headerStyle}>
                  Nomor
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  :
                </p>
                <p style={headerStyle}>
                  Tanggal
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  :
                </p>
                <p style={headerStyle}>
                  Lokasi Penyerahan &nbsp; &nbsp;&nbsp;&nbsp; : RUMAH SAKIT
                  PETROKIMIA GRESIK
                </p>
                <p style={headerStyle}>
                  {" "}
                  Syarat Penyerahan &nbsp; &nbsp;&nbsp;&nbsp; : BARANG READY
                  STOCK
                </p>
                <p style={headerStyle}>
                  Tgl. Batas Penyerahan : 10 HARI SETELAH PO TERBIT
                </p>
              </td>
            </tr>
          </tbody>
        </Table>
        <p style={headerStyle}>
          Kami orderkan kepada Saudara untuk menyerahkan/memberikan kepada kami
          barang/jasa sebagai berikut:
        </p>
        <Table borderless={true}>
          <thead>
            <tr>
              <th
                rowSpan="2"
                style={{ verticalAlign: "middle", border: "solid black 1px" }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>NO.</strong>
                </p>
              </th>
              <th colSpan="3" style={{ border: "solid black 1px" }}>
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>BARANG JASA</strong>
                </p>
              </th>
              <th
                rowSpan="2"
                style={{ verticalAlign: "middle", border: "solid black 1px" }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>HARGA</strong>
                </p>
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>SATUAN</strong>
                </p>
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>(Rp.)</strong>
                </p>
              </th>
              <th
                rowSpan="2"
                style={{
                  verticalAlign: "middle",
                  minWidth: "160px",
                  border: "solid black 1px",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>DISCOUNT</strong>
                </p>
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>(Rp.)</strong>
                </p>
              </th>
              <th
                rowSpan="2"
                style={{ verticalAlign: "middle", border: "solid black 1px" }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>HARGA</strong>
                </p>
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>(Rp.)</strong>
                </p>
              </th>
            </tr>
            <tr>
              <th style={{ border: "solid black 1px" }}>
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>URAIAN</strong>
                </p>
              </th>
              <th style={{ border: "solid black 1px" }}>
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>JUMLAH</strong>
                </p>
              </th>
              <th style={{ border: "solid black 1px" }}>
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>SATUAN</strong>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ height: "580px" }}>
              {/* <tr> */}
              <td
                style={{
                  width: "1cm",
                  verticalAlign: "top",
                  border: "solid black 1px",
                }}
              >
                {data?.DAFTARBARANG?.map((obj, index) => (
                  <p style={bodyStyle}>{index + 1}</p>
                ))}
              </td>
              <td
                style={{
                  width: "8cm",
                  verticalAlign: "top",
                  border: "solid black 1px",
                }}
              >
                {data?.DAFTARBARANG?.map((obj) => (
                  <p style={bodyStyle}>{obj?.NAMABARANG}</p>
                ))}
              </td>
              <td
                style={{
                  width: "2cm",
                  verticalAlign: "top",
                  border: "solid black 1px",
                }}
              >
                {/* <p style={bodyStyle}> */}
                {data?.DAFTARBARANG?.map((obj) => (
                  <p style={{ ...bodyStyle, textAlign: "right" }}>
                    <NumberFormat
                      value={Number(obj.JUMLAH)}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </p>
                ))}
                {/* </p> */}
              </td>
              <td
                style={{
                  width: "2cm",
                  verticalAlign: "top",
                  border: "solid black 1px",
                }}
              >
                {data?.DAFTARBARANG?.map((obj) => (
                  <p style={{ ...bodyStyle, textAlign: "right" }}>
                    {obj?.NAMASATUAN}
                  </p>
                ))}
              </td>
              <td
                style={{
                  width: "4cm",
                  verticalAlign: "top",
                  border: "solid black 1px",
                }}
              >
                {data?.DAFTARBARANG?.map((obj) => (
                  <p style={{ ...bodyStyle, textAlign: "right" }}>
                    {"Rp. "}
                    <NumberFormat
                      value={Number(obj.HARGA)}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </p>
                ))}
              </td>
              <td
                style={{
                  width: "4cm",
                  verticalAlign: "top",
                  border: "solid black 1px",
                }}
              >
                {data?.DAFTARBARANG?.map((obj) => (
                  <p style={{ ...bodyStyle, textAlign: "right" }}>
                    {"Rp. "}
                    <NumberFormat
                      value={obj.HITUNGDISKON}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </p>
                ))}
              </td>
              <td
                style={{
                  width: "5cm",
                  verticalAlign: "top",
                  border: "solid black 1px",
                }}
              >
                {data?.DAFTARBARANG?.map((obj) => (
                  <p style={{ ...bodyStyle, textAlign: "right" }}>
                    {"Rp. "}
                    <NumberFormat
                      value={obj.HITUNGHARGADANDISKON}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </p>
                ))}
              </td>
            </tr>
            <tr
              style={{
                border: "solid black 1px",
              }}
            >
              <td colSpan="5" style={{ verticalAlign: "top" }}>
                <p style={{ ...headerStyle }}>1091.A2221.A22</p>
              </td>{" "}
              <td style={{ verticalAlign: "top" }}>
                <p style={{ ...headerStyle, textAlign: "left" }}>
                  Jumlah Harga
                </p>
                <p style={{ ...headerStyle, textAlign: "left" }}>
                  Jumlah Discount
                </p>
                <p style={{ ...headerStyle, textAlign: "left" }}>PPn</p>
                <p style={{ ...headerStyle, textAlign: "left" }}>PPh22</p>
                <p style={{ ...headerStyle, textAlign: "left" }}>
                  <strong>Jumlah</strong>
                </p>
              </td>
              <td style={{ verticalAlign: "top" }}>
                <p style={{ ...headerStyle, textAlign: "right" }}>
                  {"Rp. "}
                  <NumberFormat
                    value={data?.DAFTARBARANG.reduce(
                      (a, b) => a + (b["HITUNGHARGA"] || 0),
                      0
                    )}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    decimalScale={0}
                    fixedDecimalScale={true}
                  />
                </p>
                <p style={{ ...headerStyle, textAlign: "right" }}>
                  {"Rp. "}
                  <NumberFormat
                    value={data?.DAFTARBARANG.reduce(
                      (a, b) => a + (b["HITUNGDISKON"] || 0),
                      0
                    )}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    decimalScale={0}
                    fixedDecimalScale={true}
                  />
                </p>
                <p style={{ ...headerStyle, textAlign: "right" }}>
                  {"Rp. "}
                  {data?.PPN?.trim() === "Y" ? (
                    <NumberFormat
                      value={
                        data?.DAFTARBARANG.reduce(
                          (a, b) => a + (b["HITUNGHARGADANDISKON"] || 0),
                          0
                        ) * Number(data?.NILAI_PPN - 1)
                      }
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  ) : (
                    <>0</>
                  )}
                </p>
                <p style={{ ...headerStyle, textAlign: "right" }}>
                  {"Rp. "}

                  <NumberFormat
                    value={Number(data?.PPH22)}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    decimalScale={0}
                    fixedDecimalScale={true}
                  />
                </p>
                <p style={{ ...headerStyle, textAlign: "right" }}>
                  <strong>
                    {" "}
                    {"Rp. "}
                    <NumberFormat
                      value={
                        data?.PPN?.trim() === "Y"
                          ? data?.DAFTARBARANG.reduce(
                              (a, b) => a + (b["HITUNGHARGA"] || 0),
                              0
                            ) -
                            data?.DAFTARBARANG.reduce(
                              (a, b) => a + (b["HITUNGDISKON"] || 0),
                              0
                            ) +
                            data?.DAFTARBARANG.reduce(
                              (a, b) => a + (b["HITUNGHARGADANDISKON"] || 0),
                              0
                            ) *
                              Number(data?.NILAI_PPN - 1) +
                            Number(data?.PPH22)
                          : data?.DAFTARBARANG.reduce(
                              (a, b) => a + (b["HITUNGHARGADANDISKON"] || 0),
                              0
                            ) + Number(data?.PPH22)
                      }
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </strong>
                </p>
              </td>
            </tr>
          </tbody>
        </Table>
        <br />
        <Table bordered={true}>
          <tbody>
            <tr>
              <td
                style={{
                  textAlign: "center",
                  border: "1px solid black",
                  width: "33%",
                }}
              >
                <p style={bodyStyle}>MANAJER</p>
                <p style={bodyStyle}>DEPARTEMEN PENGADAAN</p>

                <br />
                <br />
                <br />
                <hr style={{ borderBottom: "1px dashed black" }} />
              </td>
              <td
                style={{
                  textAlign: "center",
                  border: "1px solid black",
                  width: "33%",
                }}
              >
                <p style={bodyStyle}>PT PETRO GRAHA MEDIKA</p>

                <br />
                <br />
                <br />
                <br />
                <hr style={{ borderBottom: "1px dashed black" }} />
              </td>
              <td
                style={{
                  textAlign: "left",
                  border: "1px solid black",
                  width: "33%",
                }}
              >
                <p style={bodyStyle}>
                  <strong>Perhatian:</strong>
                </p>
                <p style={bodyStyle}>
                  Lembar ke-1 untuk file Saudara, sedangkan lembar lainnya
                  dikembalikan ke tempat kami setelah dibubuhkan tanda tangan
                  dan stempel
                </p>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

export default function PrintComponent(props) {
  const { handleClose, open, nopo } = props;
  const componentRef = useRef();
  const dispatch = useDispatch();
  const [dataPrint, setDataPrint] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open]);

  const fetchData = () => {
    Axios.get(urlAPI + "/v1/inventory/NSIprintpo?nopo=" + nopo, {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        setDataPrint({
          rows: response?.data?.result?.rows?.map((obj) => ({
            ...obj,
            DAFTARBARANG: obj?.DAFTARBARANG?.map((objChild) => ({
              ...objChild,
              JUMLAH: Number(objChild?.JUMLAH),
              HARGA: Number(objChild?.HARGA),
              DISKON: Number(objChild?.DISKON),
              HITUNGDISKON:
                (Number(objChild?.JUMLAH) *
                  Number(objChild?.HARGA) *
                  Number(objChild?.DISKON)) /
                100,
              HITUNGHARGA: Number(objChild?.JUMLAH) * Number(objChild?.HARGA),
              HITUNGHARGADANDISKON:
                Number(objChild?.JUMLAH) * Number(objChild?.HARGA) -
                (Number(objChild?.JUMLAH) *
                  Number(objChild?.HARGA) *
                  Number(objChild?.DISKON)) /
                  100,
            })),
          })),
        });
        setLoading(false);
        // console.log(response?.data?.result?.rows[0]?.DAFTARBARANG[0]?.);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoading(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoading(false);
        }
      });
  };

  const printStyle = `
 @media all {
  .page-break {
    display: none;
  }
}

@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
}

@media print {
  .page-break {
    margin-top: 1rem;
    display: block;
    page-break-before: auto;
  }
}

@page {
  size: auto;
  margin: 20mm;
}
  `;
  console.log("dataPrint out", dataPrint);
  return (
    <Modal
      isOpen={open}
      toggle={handleClose}
      className="modal-dialog-centered modal-xl"
      backdrop="static"
    >
      <ModalHeader toggle={handleClose}>Print Preview</ModalHeader>
      <ModalBody>
        <ReactToPrint
          trigger={() => (
            <Button
              color="primary"
              // style={{ width: "200px" }}
              block
              disabled={loading}
              // size="sm"
            >
              <Icons.Printer size={14} /> Print
            </Button>
          )}
          content={() => componentRef.current}
          pageStyle={printStyle}
        />
        <hr />
        {loading ? (
          <div className="text-center">
            <h4>Loading...</h4>
          </div>
        ) : (
          <ComponentToPrint ref={componentRef} dataPrint={dataPrint?.rows[0]} />
        )}
      </ModalBody>
    </Modal>
  );
}
